import { Link } from "react-router-dom";
import { Download, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { StarRating } from "./StarRating";

export default function ProductCard({ product, index = 0 }) {
  const { add } = useCart();

  const badgeStyle =
    product.badge === "bestseller"
      ? "bg-[#e8478e] text-white"
      : product.badge === "trending"
      ? "bg-[#2eb6a8] text-white"
      : "";

  return (
    <div
      data-testid={`product-card-${product.slug}`}
      className="group relative card-elevated overflow-hidden animate-fade-up"
      style={{ animationDelay: `${index * 60}ms`, opacity: 0 }}
    >
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative aspect-square overflow-hidden bg-[#faf4e9]">
          <img
            src={product.image_url}
            alt={product.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
          {product.badge && (
            <span
              data-testid={`badge-${product.badge}`}
              className={`absolute top-3 left-3 text-[10px] font-bold px-3 py-1.5 rounded-full uppercase tracking-[0.15em] shadow-sm ${badgeStyle}`}
            >
              {product.badge === "bestseller" ? "Best Seller" : "Trending"}
            </span>
          )}
          {product.is_digital && (
            <span className="absolute top-3 right-3 inline-flex items-center gap-1 bg-white/95 backdrop-blur-sm border border-[#e5dccd] text-[#2eb6a8] text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-[0.15em]">
              <Download size={11}/> Instant
            </span>
          )}
        </div>
      </Link>
      <div className="p-5">
        <div className="text-[10px] uppercase tracking-[0.25em] text-[#8a8076] mb-1.5 font-bold">
          {product.category}
        </div>
        <Link to={`/product/${product.slug}`}>
          <h3 className="font-display font-bold text-lg leading-snug text-[#1c1815] group-hover:text-[#e8478e] transition-colors">
            {product.title}
          </h3>
        </Link>
        {product.review_count > 0 && (
          <div className="mt-2 flex items-center gap-1.5" data-testid={`card-rating-${product.slug}`}>
            <StarRating value={product.avg_rating} size={12}/>
            <span className="text-[11px] text-[#8a8076]">({product.review_count})</span>
          </div>
        )}
        <div className="mt-4 flex items-center justify-between gap-3">
          <span className="font-display font-extrabold text-2xl text-[#1c1815]">
            ${product.price.toFixed(2)}
          </span>
          <button
            onClick={(e) => { e.preventDefault(); add(product); }}
            data-testid={`add-to-cart-${product.slug}`}
            className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-white bg-[#2eb6a8] hover:bg-[#1f8d83] hover:shadow-lg hover:-translate-y-0.5 rounded-full px-4 py-2.5 transition-all"
          >
            <ShoppingBag size={13}/> Add
          </button>
        </div>
      </div>
    </div>
  );
}
